import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, mergeProps as _mergeProps, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, withModifiers as _withModifiers, Fragment as _Fragment, renderList as _renderList, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { colspan: "4" }
const _hoisted_3 = {
  key: 1,
  style: {"color":"grey"}
}
const _hoisted_4 = {
  key: 0,
  class: "pl-3"
}
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "d-flex justify-center" }
const _hoisted_7 = { class: "d-flex justify-center" }
const _hoisted_8 = ["onClick"]
const _hoisted_9 = ["data-cy"]
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { class: "d-flex justify-center" }
const _hoisted_12 = { class: "d-flex justify-center" }
const _hoisted_13 = { class: "d-flex justify-center" }
const _hoisted_14 = { style: {"text-transform":"uppercase"} }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { colspan: "4" }
const _hoisted_17 = {
  key: 1,
  style: {"color":"grey","cursor":"pointer"}
}
const _hoisted_18 = {
  key: 0,
  class: "pl-3"
}
const _hoisted_19 = { key: 1 }
const _hoisted_20 = { class: "d-flex justify-center" }
const _hoisted_21 = { class: "d-flex justify-center" }
const _hoisted_22 = ["onClick"]
const _hoisted_23 = {
  key: 0,
  class: "pl-3"
}
const _hoisted_24 = { key: 1 }
const _hoisted_25 = { class: "d-flex justify-center" }
const _hoisted_26 = { class: "d-flex justify-center" }
const _hoisted_27 = { class: "d-flex justify-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn_primary = _resolveComponent("v-btn-primary")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn_icon = _resolveComponent("v-btn-icon")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_switch = _resolveComponent("v-switch")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_GeneralLedger = _resolveComponent("GeneralLedger")!
  const _component_v_hover = _resolveComponent("v-hover")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_v_window = _resolveComponent("v-window")!
  const _component_v_text_field_filled = _resolveComponent("v-text-field-filled")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_select_user = _resolveComponent("select-user")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_btn_next = _resolveComponent("v-btn-next")!
  const _component_UsersActivitiesHistory = _resolveComponent("UsersActivitiesHistory")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, {
    "grid-list-md": "",
    fluid: "",
    class: "mt-2"
  }, {
    default: _withCtx(() => [
      (_ctx.isAuthorized)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createVNode(_component_v_row, {
              "no-gutters": "",
              class: "mb-2"
            }, {
              default: _withCtx(() => [
                (_ctx.isAccountingUser)
                  ? (_openBlock(), _createBlock(_component_v_col, {
                      key: 0,
                      cols: "2",
                      class: "d-flex justify-center pr-2"
                    }, {
                      default: _withCtx(() => [
                        (!_ctx.stepData || !_ctx.stepData.stepCount)
                          ? (_openBlock(), _createBlock(_component_v_btn_primary, {
                              key: 0,
                              block: "",
                              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.exportDialog = true)),
                              loading: _ctx.exportLoading,
                              "data-cy": "AuditReport-exporter"
                            }, {
                              default: _withCtx(() => _cache[29] || (_cache[29] = [
                                _createTextVNode(" Exporter ")
                              ])),
                              _: 1
                            }, 8, ["loading"]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_v_col, {
                  cols: "2",
                  class: "d-flex justify-center"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_select, {
                      outlined: "",
                      disabled: !_ctx.auditReport.length,
                      modelValue: _ctx.statusFilter,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.statusFilter) = $event)),
                      items: _ctx.statusList,
                      "hide-details": "",
                      label: "Filtrer par statut",
                      "full-width": false,
                      class: "pr-2",
                      "data-cy": "AuditReport-statut",
                      density: "compact",
                      "item-title": "text"
                    }, null, 8, ["disabled", "modelValue", "items"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, {
                  cols: "2",
                  class: "d-flex justify-center"
                }, {
                  default: _withCtx(() => [
                    (_ctx.listView)
                      ? (_openBlock(), _createBlock(_component_v_select, {
                          key: 0,
                          modelValue: _ctx.selectedCycleTitle,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectedCycleTitle) = $event)),
                          outlined: "",
                          disabled: !_ctx.auditReport || !_ctx.auditReport.length,
                          "item-item-text": "cycleTitle",
                          items: _ctx.cycles,
                          "hide-details": "",
                          label: "Filtrer par cycle",
                          "full-width": false,
                          class: "pr-2",
                          "data-cy": "AuditReport-cycle",
                          density: "compact",
                          "item-title": (item) => item.cycleTitle
                        }, null, 8, ["modelValue", "disabled", "items", "item-title"]))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_spacer),
                (_ctx.listView)
                  ? (_openBlock(), _createBlock(_component_v_col, {
                      key: 1,
                      cols: "1",
                      class: "d-flex justify-center align-center"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_tooltip, { location: "bottom" }, {
                          activator: _withCtx(({ props }) => [
                            _createVNode(_component_v_btn_icon, _mergeProps({ disabled: _ctx.isGlobalReviewDisabled }, props, {
                              size: "small",
                              icon: "$fa-thumbs-up",
                              color: "green",
                              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.updateAllAuditCheckReview()))
                            }), null, 16, ["disabled"])
                          ]),
                          default: _withCtx(() => [
                            _cache[30] || (_cache[30] = _createElementVNode("span", null, "Tout superviser", -1))
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_v_col, {
                  cols: "auto",
                  class: "d-flex justify-center align-center"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_switch, {
                      modelValue: _ctx.listView,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.listView) = $event)),
                      label: "Synthèse / Comptes + Cycles",
                      "hide-details": "",
                      class: "pl-2 mt-0",
                      "data-cy": "AuditReport-liste"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            (_ctx.loading)
              ? (_openBlock(), _createBlock(_component_v_card, {
                  key: 0,
                  elevation: "0",
                  style: {"background-color":"#ffffff","border-radius":"25px"}
                }, {
                  default: _withCtx(() => [
                    (_ctx.loading)
                      ? (_openBlock(), _createBlock(_component_v_card_title, {
                          key: 0,
                          class: "pa-4 d-flex justify-center"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_progress_circular, {
                              indeterminate: "",
                              class: "mr-3"
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _: 1
                }))
              : (_ctx.listView)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    (
                        !_ctx.accountingPeriodId || !_ctx.filteredAuditReport || !_ctx.filteredAuditReport.length
                    )
                      ? (_openBlock(), _createBlock(_component_v_row, {
                          key: 0,
                          "no-gutters": ""
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_col, { cols: "12" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_card, {
                                  elevation: "0",
                                  style: {"background-color":"#ffffff","border-radius":"25px"}
                                }, {
                                  default: _withCtx(() => [
                                    (!_ctx.accountingPeriodId)
                                      ? (_openBlock(), _createBlock(_component_v_card_title, {
                                          key: 0,
                                          class: "pa-4 d-flex justify-center"
                                        }, {
                                          default: _withCtx(() => _cache[31] || (_cache[31] = [
                                            _createTextVNode(" Choisissez un exercice comptable ")
                                          ])),
                                          _: 1
                                        }))
                                      : (!_ctx.filteredAuditReport || !_ctx.filteredAuditReport.length)
                                        ? (_openBlock(), _createBlock(_component_v_card_title, {
                                            key: 1,
                                            class: "pa-4 d-flex justify-center"
                                          }, {
                                            default: _withCtx(() => _cache[32] || (_cache[32] = [
                                              _createTextVNode(" Pas de données pour l'exercice sélectionné ")
                                            ])),
                                            _: 1
                                          }))
                                        : _createCommentVNode("", true)
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    (!_ctx.loading)
                      ? (_openBlock(), _createBlock(_component_v_progress_linear, {
                          key: 1,
                          readonly: "",
                          rounded: "",
                          height: "20",
                          class: "mt-3",
                          "model-value": _ctx.globalStatusPercent,
                          color: "primary"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("strong", null, _toDisplayString(_ctx.globalStatus), 1)
                          ]),
                          _: 1
                        }, 8, ["model-value"]))
                      : _createCommentVNode("", true),
                    (!_ctx.loading && _ctx.filteredAuditReport && _ctx.filteredAuditReport.length)
                      ? (_openBlock(), _createBlock(_component_v_data_table, {
                          key: 2,
                          headers: _ctx.headers,
                          items: _ctx.filteredAuditReport,
                          class: "table mt-3",
                          "fixed-header": "",
                          height: "calc(100vh - 239px)",
                          "items-per-page": -1
                        }, {
                          item: _withCtx((props) => [
                            (props.item.type === 'cycleTitle')
                              ? (_openBlock(), _createElementBlock("tr", _hoisted_1, [
                                  _cache[33] || (_cache[33] = _createElementVNode("td", null, null, -1)),
                                  _createElementVNode("td", _hoisted_2, [
                                    _createElementVNode("h2", null, _toDisplayString(props.item.title || props.item.cycleTitle), 1)
                                  ]),
                                  _cache[34] || (_cache[34] = _createElementVNode("td", null, null, -1))
                                ]))
                              : (_ctx.disabledAuditKeys.includes(props.item.key))
                                ? (_openBlock(), _createElementBlock("tr", _hoisted_3, [
                                    _cache[37] || (_cache[37] = _createElementVNode("td", null, null, -1)),
                                    _createElementVNode("td", null, [
                                      (props.item.title)
                                        ? (_openBlock(), _createElementBlock("h3", _hoisted_4, [
                                            _createTextVNode(_toDisplayString(props.item.title
                                            ? props.item.title
                                            : _ctx.$t("audit." + props.item.key + ".title", 1)) + " - ", 1),
                                            _cache[35] || (_cache[35] = _createElementVNode("b", null, "BIENTÔT DISPONIBLE", -1))
                                          ]))
                                        : (props.item.name)
                                          ? (_openBlock(), _createElementBlock("h3", _hoisted_5, [
                                              _createTextVNode(_toDisplayString(props.item.name) + " - ", 1),
                                              _cache[36] || (_cache[36] = _createElementVNode("b", null, "BIENTÔT DISPONIBLE", -1))
                                            ]))
                                          : _createCommentVNode("", true)
                                    ]),
                                    _createElementVNode("td", null, [
                                      _createVNode(_component_v_progress_linear, {
                                        readonly: "",
                                        rounded: "",
                                        color: "green",
                                        height: "7",
                                        disabled: ""
                                      })
                                    ]),
                                    _createElementVNode("td", null, [
                                      _createElementVNode("div", _hoisted_6, [
                                        _createVNode(_component_v_icon, {
                                          icon: "$oss-circle-check",
                                          size: "small",
                                          color: "primary"
                                        })
                                      ])
                                    ]),
                                    _createElementVNode("td", null, [
                                      _createElementVNode("div", _hoisted_7, [
                                        _createVNode(_component_v_btn_icon, {
                                          icon: "$fa-thumbs-up",
                                          color: "green",
                                          size: "small",
                                          disabled: ""
                                        })
                                      ])
                                    ]),
                                    _cache[38] || (_cache[38] = _createElementVNode("td", null, null, -1))
                                  ]))
                                : (_openBlock(), _createElementBlock("tr", {
                                    key: 2,
                                    onClick: _withModifiers(($event: any) => (_ctx.openAudit(props.item)), ["stop"]),
                                    style: {"cursor":"pointer"}
                                  }, [
                                    _cache[40] || (_cache[40] = _createElementVNode("td", null, null, -1)),
                                    _createElementVNode("td", null, [
                                      (props.item.title)
                                        ? (_openBlock(), _createElementBlock("h3", {
                                            key: 0,
                                            "data-cy": 'AuditReport-' + props.item.key
                                          }, [
                                            _createTextVNode(_toDisplayString(props.item.title
                                            ? props.item.title
                                            : _ctx.$t("audit." + props.item.key + ".title", 1)) + " ", 1),
                                            (
                                            props.item.action &&
                                            props.item.action.pathName !== 'manual-audit'
                                        )
                                              ? (_openBlock(), _createBlock(_component_v_icon, {
                                                  key: 0,
                                                  class: "ml-2",
                                                  color: "ternary",
                                                  size: "x-small"
                                                }, {
                                                  default: _withCtx(() => _cache[39] || (_cache[39] = [
                                                    _createTextVNode("$fa-magic")
                                                  ])),
                                                  _: 1
                                                }))
                                              : _createCommentVNode("", true)
                                          ], 8, _hoisted_9))
                                        : (props.item.name)
                                          ? (_openBlock(), _createElementBlock("h3", _hoisted_10, _toDisplayString(props.item.name), 1))
                                          : _createCommentVNode("", true)
                                    ]),
                                    _createElementVNode("td", null, [
                                      _createVNode(_component_v_progress_linear, {
                                        readonly: "",
                                        rounded: "",
                                        color: "green",
                                        height: "7",
                                        "model-value": _ctx.getAuditCheckProgress(props.item)
                                      }, null, 8, ["model-value"])
                                    ]),
                                    _createElementVNode("td", null, [
                                      _createElementVNode("div", _hoisted_11, [
                                        _createVNode(_component_v_icon, {
                                          icon: 
                                            props.item.status && props.item.status === 'VALIDATED'
                                                ? '$oss-circle-check'
                                                : '$oss-circle-uncheck'
                                        ,
                                          size: "small",
                                          color: 
                                            props.item.status && props.item.status === 'VALIDATED'
                                                ? 'primary'
                                                : 'secondary'
                                        
                                        }, null, 8, ["icon", "color"])
                                      ])
                                    ]),
                                    _createElementVNode("td", null, [
                                      _createElementVNode("div", _hoisted_12, [
                                        _createVNode(_component_v_btn_icon, {
                                          icon: _ctx.getAuditReviewIcon(props.item),
                                          color: _ctx.getAuditReviewIconColor(props.item),
                                          disabled: 
                                            props.item.status !== 'VALIDATED' || !_ctx.isEnableReview
                                        ,
                                          onClick: _withModifiers(($event: any) => (_ctx.updateAuditCheckReview(props.item)), ["stop"]),
                                          size: "small"
                                        }, null, 8, ["icon", "color", "disabled", "onClick"])
                                      ])
                                    ]),
                                    _createElementVNode("td", null, [
                                      _createElementVNode("div", _hoisted_13, [
                                        _createVNode(_component_v_btn_icon, {
                                          icon: "$oss-activity",
                                          color: "primary",
                                          onClick: _withModifiers(($event: any) => {
                                            _ctx.displayActivityDialog = true;
                                            _ctx.displayAuditCheckActivityKey = props.item.key;
                                        }, ["stop"])
                                        }, null, 8, ["onClick"])
                                      ])
                                    ]),
                                    _cache[41] || (_cache[41] = _createElementVNode("td", null, null, -1))
                                  ], 8, _hoisted_8))
                          ]),
                          _: 1
                        }, 8, ["headers", "items"]))
                      : _createCommentVNode("", true)
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                    _createVNode(_component_v_row, { "no-gutters": "" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_tabs, {
                          modelValue: _ctx.selectedCycleTab,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.selectedCycleTab) = $event)),
                          class: "d-flex justify-center",
                          style: {"border-radius":"16px"},
                          "center-active": ""
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_tab, { "model-value": -1 }, {
                              default: _withCtx(() => _cache[42] || (_cache[42] = [
                                _createTextVNode(" Balance ")
                              ])),
                              _: 1
                            }),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabCycles, (cycle) => {
                              return (_openBlock(), _createBlock(_component_v_tab, {
                                key: cycle.cycleTitle,
                                class: "d-flex justify-space-between",
                                "model-value": cycle
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(cycle.cycleTitle), 1)
                                ]),
                                _: 2
                              }, 1032, ["model-value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_row, { "no-gutters": "" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_window, {
                          style: {"width":"100%"},
                          class: "mt-1",
                          modelValue: _ctx.selectedCycleTab,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.selectedCycleTab) = $event))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_window_item, { style: {"width":"100%"} }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_row, { "no-gutters": "" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_hover, null, {
                                      default: _withCtx(({ isHovering, props }) => [
                                        _createVNode(_component_v_col, _mergeProps({
                                          cols: isHovering ? 3 : 1
                                        }, props), {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_list, _mergeProps(props, {
                                              style: {"border-radius":"16px","height":"72vh"},
                                              class: "mt-3"
                                            }), {
                                              default: _withCtx(() => [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabCycles, (cycle) => {
                                                  return (_openBlock(), _createBlock(_component_v_list_item, {
                                                    key: cycle.index,
                                                    class: "d-flex align-center",
                                                    onClick: ($event: any) => (_ctx.selectedCycleGLTab = cycle),
                                                    "model-value": cycle
                                                  }, {
                                                    default: _withCtx(() => [
                                                      (cycle.cycleTitle.length > 35)
                                                        ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                                            key: 0,
                                                            location: "top"
                                                          }, {
                                                            activator: _withCtx(({ props }) => [
                                                              _createElementVNode("p", _mergeProps({ ref_for: true }, props, {
                                                                class: 
                                                                cycle.index ===
                                                                _ctx.selectedCycleGLTab.index
                                                                    ? 'text-primary'
                                                                    : ''
                                                            ,
                                                                style: {"text-transform":"uppercase"}
                                                              }), _toDisplayString(_ctx.getDisplayedTitle(
                                                                    cycle.cycleTitle,
                                                                    isHovering,
                                                                )), 17)
                                                            ]),
                                                            default: _withCtx(() => [
                                                              _createElementVNode("span", _hoisted_14, _toDisplayString(cycle.cycleTitle), 1)
                                                            ]),
                                                            _: 2
                                                          }, 1024))
                                                        : (_openBlock(), _createElementBlock("p", {
                                                            key: 1,
                                                            style: {"text-transform":"uppercase"},
                                                            class: _normalizeClass(
                                                        cycle.index === _ctx.selectedCycleGLTab.index
                                                            ? 'text-primary'
                                                            : ''
                                                    )
                                                          }, _toDisplayString(_ctx.getDisplayedTitle(
                                                            cycle.cycleTitle.toUpperCase(),
                                                            isHovering,
                                                        )), 3))
                                                    ]),
                                                    _: 2
                                                  }, 1032, ["onClick", "model-value"]))
                                                }), 128))
                                              ]),
                                              _: 2
                                            }, 1040)
                                          ]),
                                          _: 2
                                        }, 1040, ["cols"]),
                                        _createVNode(_component_v_col, {
                                          cols: isHovering ? 9 : 11,
                                          style: {"height":"calc(100vh - 200px)"}
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_card, {
                                              elevation: "0",
                                              style: {"background-color":"#ffffff","border-radius":"16px"},
                                              class: "ml-3 mt-3"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_card_title, { class: "d-flex justify-start py-2" }, {
                                                  default: _withCtx(() => [
                                                    _createTextVNode(" Racines des comptes concernées par le cycle : " + _toDisplayString(_ctx.templateAccountableAccountRoots), 1)
                                                  ]),
                                                  _: 1
                                                }),
                                                (_ctx.templateExcludedAccountableAccountRoots)
                                                  ? (_openBlock(), _createBlock(_component_v_card_title, {
                                                      key: 0,
                                                      class: "d-flex justify-start pt-0 pb-2"
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createTextVNode(" Racines des comptes exclus : " + _toDisplayString(_ctx.templateExcludedAccountableAccountRoots), 1)
                                                      ]),
                                                      _: 1
                                                    }))
                                                  : _createCommentVNode("", true)
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(_component_GeneralLedger, {
                                              ref: "generalLedger",
                                              companyId: _ctx.companyId,
                                              accountingPeriodId: _ctx.accountingPeriodId,
                                              accountableAccountFilter: 
                                                _ctx.selectedCycleGLTab.accountableAccountsRoot
                                            ,
                                              excludedAccountableAccountFilter: 
                                                _ctx.selectedCycleGLTab.excludedAccountableAccountsRoot ||
                                                []
                                            ,
                                              hideOptions: true,
                                              inThirdParty: false,
                                              enableAuditedAccountableAccounts: true,
                                              tableHeight: '65vh',
                                              hideBodyAppend: true,
                                              inNm1: true
                                            }, null, 8, ["companyId", "accountingPeriodId", "accountableAccountFilter", "excludedAccountableAccountFilter"])
                                          ]),
                                          _: 2
                                        }, 1032, ["cols"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabCycles, (cycle) => {
                              return (_openBlock(), _createBlock(_component_v_window_item, {
                                style: {"width":"100%"},
                                key: cycle.indexStart
                              }, {
                                default: _withCtx(() => [
                                  (!_ctx.loading)
                                    ? (_openBlock(), _createBlock(_component_v_data_table, {
                                        key: 0,
                                        headers: _ctx.headers,
                                        items: _ctx.cycleTableItems,
                                        class: "table mt-3",
                                        "fixed-header": "",
                                        height: "calc(100vh - 275px)",
                                        "items-per-page": -1
                                      }, {
                                        item: _withCtx((props) => [
                                          (props.item.type === 'cycleTitle')
                                            ? (_openBlock(), _createElementBlock("tr", _hoisted_15, [
                                                _cache[43] || (_cache[43] = _createElementVNode("td", null, null, -1)),
                                                _createElementVNode("td", _hoisted_16, [
                                                  _createElementVNode("h2", null, _toDisplayString(props.item.title || props.item.cycleTitle), 1)
                                                ]),
                                                _cache[44] || (_cache[44] = _createElementVNode("td", null, null, -1))
                                              ]))
                                            : (_ctx.disabledAuditKeys.includes(props.item.key))
                                              ? (_openBlock(), _createElementBlock("tr", _hoisted_17, [
                                                  _cache[47] || (_cache[47] = _createElementVNode("td", null, null, -1)),
                                                  _createElementVNode("td", null, [
                                                    (props.item.title)
                                                      ? (_openBlock(), _createElementBlock("h3", _hoisted_18, [
                                                          _createTextVNode(_toDisplayString(props.item.title
                                                        ? props.item.title
                                                        : _ctx.$t(
                                                              "audit." + props.item.key + ".title",
                                                              1,
                                                          )) + " - ", 1),
                                                          _cache[45] || (_cache[45] = _createElementVNode("b", null, "BIENTÔT DISPONIBLE", -1))
                                                        ]))
                                                      : (props.item.name)
                                                        ? (_openBlock(), _createElementBlock("h3", _hoisted_19, [
                                                            _createTextVNode(_toDisplayString(props.item.name) + " - ", 1),
                                                            _cache[46] || (_cache[46] = _createElementVNode("b", null, "BIENTÔT DISPONIBLE", -1))
                                                          ]))
                                                        : _createCommentVNode("", true)
                                                  ]),
                                                  _createElementVNode("td", null, [
                                                    _createVNode(_component_v_progress_linear, {
                                                      readonly: "",
                                                      rounded: "",
                                                      color: "green",
                                                      height: "7",
                                                      disabled: ""
                                                    })
                                                  ]),
                                                  _createElementVNode("td", null, [
                                                    _createElementVNode("div", _hoisted_20, [
                                                      _createVNode(_component_v_icon, {
                                                        icon: "$oss-circle-check",
                                                        size: "small",
                                                        color: "primary"
                                                      })
                                                    ])
                                                  ]),
                                                  _createElementVNode("td", null, [
                                                    _createElementVNode("div", _hoisted_21, [
                                                      _createVNode(_component_v_btn_icon, {
                                                        icon: "$fa-thumbs-up",
                                                        color: "green",
                                                        size: "small",
                                                        disabled: ""
                                                      })
                                                    ])
                                                  ]),
                                                  _cache[48] || (_cache[48] = _createElementVNode("td", null, null, -1))
                                                ]))
                                              : (_openBlock(), _createElementBlock("tr", {
                                                  key: 2,
                                                  onClick: _withModifiers(($event: any) => (_ctx.openAudit(props.item)), ["stop"]),
                                                  style: {"cursor":"pointer"}
                                                }, [
                                                  _cache[49] || (_cache[49] = _createElementVNode("td", null, null, -1)),
                                                  _createElementVNode("td", null, [
                                                    (props.item.title)
                                                      ? (_openBlock(), _createElementBlock("h3", _hoisted_23, _toDisplayString(props.item.title
                                                        ? props.item.title
                                                        : _ctx.$t(
                                                              "audit." + props.item.key + ".title",
                                                              1,
                                                          )), 1))
                                                      : (props.item.name)
                                                        ? (_openBlock(), _createElementBlock("h3", _hoisted_24, _toDisplayString(props.item.name), 1))
                                                        : _createCommentVNode("", true)
                                                  ]),
                                                  _createElementVNode("td", null, [
                                                    _createVNode(_component_v_progress_linear, {
                                                      readonly: "",
                                                      rounded: "",
                                                      color: "secondary",
                                                      height: "7",
                                                      "model-value": _ctx.getAuditCheckProgress(props.item)
                                                    }, null, 8, ["model-value"])
                                                  ]),
                                                  _createElementVNode("td", null, [
                                                    _createElementVNode("div", _hoisted_25, [
                                                      _createVNode(_component_v_icon, {
                                                        icon: 
                                                        props.item.status &&
                                                        props.item.status === 'VALIDATED'
                                                            ? '$oss-circle-check'
                                                            : '$oss-circle-uncheck'
                                                    ,
                                                        size: "small",
                                                        color: 
                                                        props.item.status &&
                                                        props.item.status === 'VALIDATED'
                                                            ? 'primary'
                                                            : 'secondary'
                                                    
                                                      }, null, 8, ["icon", "color"])
                                                    ])
                                                  ]),
                                                  _createElementVNode("td", null, [
                                                    _createElementVNode("div", _hoisted_26, [
                                                      _createVNode(_component_v_btn_icon, {
                                                        icon: _ctx.getAuditReviewIcon(props.item),
                                                        color: _ctx.getAuditReviewIconColor(props.item),
                                                        disabled: 
                                                        props.item.status !== 'VALIDATED' ||
                                                        !_ctx.isEnableReview
                                                    ,
                                                        onClick: _withModifiers(($event: any) => (_ctx.updateAuditCheckReview(props.item)), ["stop"]),
                                                        size: "small"
                                                      }, null, 8, ["icon", "color", "disabled", "onClick"])
                                                    ])
                                                  ]),
                                                  _createElementVNode("td", null, [
                                                    _createElementVNode("div", _hoisted_27, [
                                                      _createVNode(_component_v_btn_icon, {
                                                        icon: "$oss-activity",
                                                        color: "primary",
                                                        onClick: _withModifiers(($event: any) => {
                                                        _ctx.displayActivityDialog = true;
                                                        _ctx.displayAuditCheckActivityKey =
                                                            props.item.key;
                                                    }, ["stop"])
                                                      }, null, 8, ["onClick"])
                                                    ])
                                                  ]),
                                                  _cache[50] || (_cache[50] = _createElementVNode("td", null, null, -1))
                                                ], 8, _hoisted_22))
                                        ]),
                                        _: 1
                                      }, 8, ["headers", "items"]))
                                    : _createCommentVNode("", true)
                                ]),
                                _: 2
                              }, 1024))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ], 64)),
            (_ctx.dialogGenerateLiasse)
              ? (_openBlock(), _createBlock(_component_oss_dialog, {
                  key: 3,
                  modelValue: _ctx.dialogGenerateLiasse,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.dialogGenerateLiasse) = $event)),
                  title: "Synthèse pour la génération de la liasse",
                  "previous-display": _ctx.generateLiasseStep !== 0,
                  "valid-disabled": !_ctx.signer,
                  onValid: _cache[13] || (_cache[13] = ($event: any) => (_ctx.generateTaxReturn())),
                  onPrevious: _cache[14] || (_cache[14] = ($event: any) => (_ctx.generateLiasseStep = 0)),
                  onClose: _cache[15] || (_cache[15] = ($event: any) => (_ctx.generateLiasseStep = 0)),
                  "min-width": "60vw"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_window, {
                      modelValue: _ctx.generateLiasseStep,
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.generateLiasseStep) = $event))
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(), _createBlock(_component_v_window_item, { key: 0 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_row, {
                              "no-gutters": "",
                              class: "pt-2"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, {
                                  cols: "4",
                                  class: "px-1"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_text_field_filled, {
                                      readonly: "",
                                      label: "Signataire",
                                      onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.generateLiasseStep = 1)),
                                      outlined: "",
                                      "hide-details": "",
                                      "model-value": 
                                        _ctx.signer
                                            ? `${_ctx.signer.firstname || ''} ${_ctx.signer.lastname || ''}`
                                            : ''
                                    ,
                                      density: "compact"
                                    }, null, 8, ["model-value"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_col, {
                                  cols: "4",
                                  class: "px-1"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_text_field_filled, {
                                      modelValue: _ctx.options.signer.quality,
                                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.options.signer.quality) = $event)),
                                      label: "Qualité",
                                      outlined: "",
                                      "hide-details": "",
                                      density: "compact"
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_col, { cols: "4" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_text_field_filled, {
                                      modelValue: _ctx.options.signer.city,
                                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.options.signer.city) = $event)),
                                      label: "Lieu",
                                      outlined: "",
                                      "hide-details": "",
                                      density: "compact"
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_col, { cols: "12" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_divider, { class: "my-2" })
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_col, {
                                  cols: "4",
                                  class: "px-1"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_text_field_filled, {
                                      readonly: "",
                                      label: "Société",
                                      outlined: "",
                                      "hide-details": "",
                                      "model-value": _ctx.company.displayName || _ctx.company.name,
                                      density: "compact"
                                    }, null, 8, ["model-value"])
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_col, {
                                  cols: "6",
                                  class: "px-1"
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_text_field_filled, {
                                      readonly: "",
                                      label: "Période comptable",
                                      outlined: "",
                                      "hide-details": "",
                                      "model-value": `${_ctx.formatDate(
                                        _ctx.accountingPeriod.start,
                                    )} - ${_ctx.formatDate(_ctx.accountingPeriod.end)}`,
                                      density: "compact"
                                    }, null, 8, ["model-value"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })),
                        (_openBlock(), _createBlock(_component_v_window_item, { key: 1 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_row, { "no-gutters": "" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_col, { cols: "12" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_select_user, {
                                      class: "px-1",
                                      modelValue: _ctx.signer,
                                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.signer) = $event)),
                                      companyId: _ctx.userCompanyId,
                                      type: 'NATURAL_PERSON',
                                      withEmail: true
                                    }, null, 8, ["modelValue", "companyId"])
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["modelValue", "previous-display", "valid-disabled"]))
              : _createCommentVNode("", true),
            (_ctx.exportDialog)
              ? (_openBlock(), _createBlock(_component_oss_dialog, {
                  key: 4,
                  modelValue: _ctx.exportDialog,
                  "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.exportDialog) = $event)),
                  title: "Exporter l'extrait",
                  onClose: _cache[23] || (_cache[23] = ($event: any) => (_ctx.resetExportDialog())),
                  onPrevious: _cache[24] || (_cache[24] = ($event: any) => (_ctx.exportWindowStep = 0)),
                  "previous-display": _ctx.exportWindowStep > 0,
                  "valid-title": _ctx.exportWindowStep === 2 ? 'Valider' : 'Suivant',
                  "hide-valid": _ctx.exportWindowStep !== 0,
                  onValid: _cache[25] || (_cache[25] = ($event: any) => (_ctx.nextStepExportDialog())),
                  prefixDataCy: "AuditReport-valid",
                  "min-width": "800px"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_window, {
                      modelValue: _ctx.exportWindowStep,
                      "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.exportWindowStep) = $event))
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(), _createBlock(_component_v_window_item, { key: 0 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_checkbox, {
                              class: "pb-1 ma-0",
                              "hide-details": "",
                              dense: "",
                              modelValue: _ctx.exportShortComment,
                              "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.exportShortComment) = $event)),
                              label: "Commentaires synthétiques"
                            }, null, 8, ["modelValue"]),
                            _createVNode(_component_v_checkbox, {
                              class: "pb-1 ma-0",
                              "hide-details": "",
                              dense: "",
                              modelValue: _ctx.exportFullComment,
                              "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.exportFullComment) = $event)),
                              label: "Commentaires détaillés"
                            }, null, 8, ["modelValue"]),
                            _createVNode(_component_v_checkbox, {
                              class: "pb-1 ma-0",
                              "hide-details": "",
                              dense: "",
                              modelValue: _ctx.exportAnnexes,
                              "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.exportAnnexes) = $event)),
                              label: "Annexes"
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })),
                        (_openBlock(), _createBlock(_component_v_window_item, { key: 1 }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_list, {
                              subheader: "",
                              lines: "two"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_list_item, {
                                  class: _normalizeClass(
                                    !_ctx.$vuetify.display.mobile
                                        ? 'mb-2 oss-list-item rounded-lg'
                                        : 'mb-2 px-2 oss-list-item rounded-lg'
                                ),
                                  onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.exportFile('DOCX'))),
                                  "data-cy": "AuditReport-docs"
                                }, {
                                  prepend: _withCtx(() => [
                                    _createVNode(_component_v_icon, { color: "secondary" }, {
                                      default: _withCtx(() => _cache[51] || (_cache[51] = [
                                        _createTextVNode("$fa-file-word ")
                                      ])),
                                      _: 1
                                    })
                                  ]),
                                  append: _withCtx(() => [
                                    _createVNode(_component_v_btn_next)
                                  ]),
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_list_item_title, null, {
                                      default: _withCtx(() => _cache[52] || (_cache[52] = [
                                        _createTextVNode("Docx")
                                      ])),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["class"]),
                                _createVNode(_component_v_list_item, {
                                  class: _normalizeClass(
                                    !_ctx.$vuetify.display.mobile
                                        ? 'mb-2 oss-list-item rounded-lg'
                                        : 'mb-2 px-2 oss-list-item rounded-lg'
                                ),
                                  onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.exportFile('PDF'))),
                                  "data-cy": "AuditReport-PDF"
                                }, {
                                  prepend: _withCtx(() => [
                                    _createVNode(_component_v_icon, { color: "secondary" }, {
                                      default: _withCtx(() => _cache[53] || (_cache[53] = [
                                        _createTextVNode(" $fa-file-pdf ")
                                      ])),
                                      _: 1
                                    })
                                  ]),
                                  append: _withCtx(() => [
                                    _createVNode(_component_v_btn_next)
                                  ]),
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_list_item_title, null, {
                                      default: _withCtx(() => _cache[54] || (_cache[54] = [
                                        _createTextVNode("Pdf")
                                      ])),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }, 8, ["class"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["modelValue", "previous-display", "valid-title", "hide-valid"]))
              : _createCommentVNode("", true),
            (_ctx.displayActivityDialog)
              ? (_openBlock(), _createBlock(_component_oss_dialog, {
                  key: 5,
                  modelValue: _ctx.displayActivityDialog,
                  "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.displayActivityDialog) = $event)),
                  title: "Activité",
                  "valid-title": "Fermer",
                  onValid: _cache[27] || (_cache[27] = ($event: any) => (_ctx.displayActivityDialog = false)),
                  onClose: _cache[28] || (_cache[28] = ($event: any) => {
                    _ctx.displayActivityDialog = false;
                    _ctx.displayAuditCheckActivityKey = null;
                }),
                  "min-width": "60vw"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_UsersActivitiesHistory, {
                      auditCheckKey: _ctx.displayAuditCheckActivityKey,
                      accountingPeriodId: _ctx.accountingPeriodId
                    }, null, 8, ["auditCheckKey", "accountingPeriodId"])
                  ]),
                  _: 1
                }, 8, ["modelValue"]))
              : _createCommentVNode("", true)
          ], 64))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}